import { AfterViewInit, Directive, ElementRef, Input, Renderer2, ViewChild } from '@angular/core';
import { TrustpilotService } from './trustpilot-widget.service';

@Directive()
export abstract class TrustpilotWidgetComponentDef implements AfterViewInit {
    constructor(
        protected trustpilotService: TrustpilotService,
        private renderer2: Renderer2
    ) {}

    @ViewChild('container')
    private container?: ElementRef<HTMLDivElement>;

    @Input()
    url?: string;

    @Input()
    locale?: string;

    @Input({ required: true })
    templateId!: string;

    @Input({ required: true })
    businessunitId!: string;

    @Input()
    styleHeight?: string;

    @Input()
    styleWidth?: string;

    @Input()
    theme?: string;

    @Input()
    tags?: string;

    @Input()
    stars?: string;

    @Input()
    starColor?: string;

    @Input()
    noReviews?: string;

    @Input()
    scrollToList?: string;

    @Input()
    sku?: string;

    @Input()
    fontFamily?: string;

    @Input()
    reviewLanguages?: string;

    @Input()
    styleAlignment?: string;

    ngAfterViewInit(): void {
        this.update();
    }

    protected update(): void {
        const trustboxRef = this.trustboxRef;
        if (trustboxRef) {
            this.renderer2.setAttribute(trustboxRef, 'data-locale', this.locale || 'en-GB');
            this.renderer2.setAttribute(trustboxRef, 'data-template-id', this.templateId);
            this.renderer2.setAttribute(trustboxRef, 'data-businessunit-id', this.businessunitId);
            if (this.styleHeight) {
                this.renderer2.setAttribute(trustboxRef, 'data-style-height', this.styleHeight);
            }
            if (this.styleWidth) {
                this.renderer2.setAttribute(trustboxRef, 'data-style-width', this.styleWidth);
            }
            if (this.theme) {
                this.renderer2.setAttribute(trustboxRef, 'data-theme', this.theme);
            }
            if (this.starColor) {
                this.renderer2.setAttribute(trustboxRef, 'data-star-color', this.starColor);
            }
            if (this.scrollToList) {
                this.renderer2.setAttribute(trustboxRef, 'data-scroll-to-list', this.scrollToList);
            }
            if (this.noReviews) {
                this.renderer2.setAttribute(trustboxRef, 'data-no-reviews', this.noReviews);
            }
            if (this.sku) {
                this.renderer2.setAttribute(trustboxRef, 'data-sku', this.sku);
            }
            if (this.fontFamily) {
                this.renderer2.setAttribute(trustboxRef, 'data-font-family', this.fontFamily);
            }
            if (this.reviewLanguages) {
                this.renderer2.setAttribute(trustboxRef, 'data-review-languages', this.reviewLanguages);
            }
            if (this.styleAlignment) {
                this.renderer2.setAttribute(trustboxRef, 'data-style-alignment', this.styleAlignment);
            }
            if (this.tags) {
                this.renderer2.setAttribute(trustboxRef, 'data-tags', this.tags);
            }
            if (this.stars) {
                this.renderer2.setAttribute(trustboxRef, 'data-stars', this.stars);
            }
            this.trustpilotService.load(() => {
                if (this.trustpilotService.api) {
                    this.trustpilotService.api.loadFromElement(trustboxRef);
                }
            });
        }
    }

    protected get trustboxRef(): HTMLDivElement | undefined {
        return this.container?.nativeElement;
    }
}
